/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import * as Leaflet from 'leaflet'
import {DestinationHostVO} from '@/valueObjects/DestinationHostVO'
import {latLng, LatLngExpression} from 'leaflet'

// OCD's coordinates (where this app is executed)
const startCoordinates = latLng(48.893453, 2.230915)

@Component({})
export default class AnalysisNetworkMap extends Vue {

    private static getLocationString(host: DestinationHostVO): string {
        if (host.city !== '' && host.country !== '') {
            return `${host.city}, ${host.country}`
        }
        if (host.country !== '') {
            return host.country
        }
        if (host.city !== '') {
            return host.country
        }
        return ''
    }

    @Prop()
    private hosts: DestinationHostVO[]

    private map: Leaflet.Map

    public mounted() {
        this.displayMap()
    }

    private displayMap() {
        // Fills the div identified by 'mapId' with a world map
        // (the component needs to be mounted before creating the map with the leaflet library)
        this.map = Leaflet.map('mapId')
        const tileLayer = Leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        })
        tileLayer.addTo(this.map)
        this.map.setView(startCoordinates, 2)
    }

    @Watch('hosts', {immediate: true})
    private addHostsToMap() {
        for (const host of this.hosts) {
            this.addHostToMap(host)
        }
    }

    private addHostToMap(host: DestinationHostVO) {
        if (this.map === undefined) {
            return
        }

        if (host.latitude !== undefined && host.longitude !== undefined) {
            this.addMarkerWithTooltip(host.latitude, host.longitude, host)
            this.drawLineTo(host.latitude, host.longitude)
        }
    }

    private addMarkerWithTooltip(latitude: number, longitude: number, host: DestinationHostVO) {
        const locationString = AnalysisNetworkMap.getLocationString(host)
        Leaflet.marker([latitude, longitude])
            .addTo(this.map)
            .bindTooltip(locationString)
    }

    private drawLineTo(latitude: number, longitude: number) {

        const destCoordinates = latLng(latitude, longitude)

        Leaflet.polyline([startCoordinates, destCoordinates], { color: 'black', weight: 1 }).addTo(this.map)
    }

}
